import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SUPPORT_MAIL } from '../assets/constants/Constants';

const SupportScreenPage = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const colorScheme = theme.palette.mode

     return (
        <div className='support-screen-page'>
            <div className='main-container'>
                <div className='main'>
                    <div className="container">
                        <div className="linkingGroup">
                            <p className='title' sx={{color : theme.palette.text.primary}}>{t('sendEmailText')}</p>
                            <a className='link-class' href={`mailto:${SUPPORT_MAIL}`}> {t('supportWeblink')}</a>
                            <p className='title' sx={{color : theme.palette.text.primary}}>{t('suggesstionsText')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportScreenPage;